<script>
import { defineComponent, inject, ref, computed, onMounted, watch } from 'vue'
import HierarchyTreePicker from "@/components/cHierarchyTreePicker.vue"
import axios from "axios"

export default defineComponent({
  name: 'EvaluateNew',
  components: {
    HierarchyTreePicker,
  },
  props: {
    open: {
      type: Boolean,
      required: false
    },
  },
  emits: ['docCreated', 'error', 'sessionExpired'],
  setup(props, { emit }) {
    const loginState = inject('loginState')
    const store = inject('store')
    const router = inject('router');
    const hierarchiesLoading = computed(() => store.state.hierarchies.loading)
    const viewState = ref('hierarchy');
    const message = ref('');
    const response = ref(null);
    const creationDisabled = ref(false);
    const useTreePicker = true;
    const levellingTemplates = computed(() => loginState.user.createDocumentDialogOptions.filter(dt => dt.lifecycles.some(l => l.dataCaptures.some(dc => dc.questionnaire_control_type === 'LEVELLING'))))
    const selectedTemplate = ref(null)
    const selectedActionId = computed(() => selectedTemplate.value.lifecycles.find(l => l.showInCreateDialog).lifecycle_action_id)
    const multiLifecycles = computed(() => selectedTemplate.value.lifecycles.filter(l => l.showInCreateDialog))
    const selectedAction = ref(null)
    const selectedActionNonDefault = ref(false)
    const selectedHierarchies = ref(null)
    const createExtraFields = ref([])
    const currentFields = ref([])
    const useInheritSkills = ref(false)
    const useTranslation = ref(false)
    const hierarchies = computed(() => store.state.hierarchies.hierarchies)
    const fileUploadFormData = ref({})
    const applicableHierarchyTypes = ref([])
    const newDoc = ref(null)

    onMounted(async () => {
      if (props.open) dialogueOpened()
    })

    watch(() => props.open, (open) => {
      if (open) dialogueOpened()
    })

    watch(selectedTemplate, (val) => {
      if (val) initialize()
    })

    async function dialogueOpened() {
      if (hierarchiesLoading.value) {
        viewState.value = 'loading'
        const unwatch = watch(hierarchiesLoading, (newVal) => {
          if (!newVal) {
            unwatch()
            initialize()
          }
        })
      } else {
        initialize()
      }
    }

    async function initialize() {
      if (!selectedTemplate.value && levellingTemplates.value.length) {
        selectedTemplate.value = levellingTemplates.value[levellingTemplates.value.length - 1]
      }
      if (!selectedTemplate.value) {
        viewState.value = 'hierarchy';
        return;
      }
      applicableHierarchyTypes.value = hierarchies.value.filter(
        (x) =>
          !selectedTemplate.value.hiddenHierarchyTypes.some((h) => h === x.ht_id)
      ).map((ht) => {
        const local = { ...ht, lostFocus: false };
        // check for possibility of allow add leaf node
        local.allowAddLeafNode = false;
        if (selectedActionId.value) {
          let selLifeCyle = selectedTemplate.value.lifecycles.find(
            (x) => x.lifecycle_action_id === selectedActionId.value
          );
          let lifecycleActions = selLifeCyle
            ? selectedTemplate.value.lifecycles.filter(
              (x) => x.lifecycle_id === selLifeCyle.lifecycle_id
            )
            : [];
          local.allowAddLeafNode =
            lifecycleActions.length &&
            lifecycleActions.some((a) =>
              a.ht_id_can_add_node.some((n) => n === local.ht_id)
            );
        }
        return local;
      });

      viewState.value = 'hierarchy';
    }

    function onHrySelect(ht) {
      ht.newLeafNodeAdded = false;

      // isActionSelected = applicableHierarchyTypes.some(
      //   (h) => h.treePickerValue === -999
      // );

      setSelected();
      // checkCriteriaRules();
      // buildFilters();

    }

    function nodeAdded(ht, newNode) {

      ht.newLeafNodeAdded = true;
      ht.treePickerValue = newNode.hierarchy_node.hr_id;

      //isActionSelected = true;
      setSelected();
      // checkCriteriaRules();
      // buildFilters();
    }

    function setSelected() {
      selectedAction.value = null;
      selectedHierarchies.value = null;
      if (!selectedTemplate.value) return;
      selectedHierarchies.value = applicableHierarchyTypes.value.map((h) => {
        let hr = null;
        if (useTreePicker) {
          hr = { value: h.treePickerValue };
        } else {
          hr = h.values.find(
            (v) =>
              v.text.toLowerCase() === (h.hierarchy_text || "").toLowerCase() &&
              v.value
          );
        }
        let ret = {
          ht_id: h.ht_id,
          ht_name: h.label.replace("Select ", ""),
          hr_id: hr ? hr.value : h.hierarchy_text,
          isNew: hr ? false : true,
          wasMissing: h.missing,
          hrAdded: !!h.newLeafNodeAdded,
        };
        if (ret.isNew && !h.levels.some((l) => !l.selected)) {
          let missing = false;
          h.levels.forEach((l) => {
            ret["level" + l.index] = l.selected.text;
            if (!l.selected.text) missing = true;
          });
          if (missing) {
            h.levels.forEach((l) => {
              ret["level" + l.index] = null;
            });
          }
        }
        return ret;
      });

      if (selectedTemplate.value.lifecyclesHT.length) {
        let htTrigger = selectedHierarchies.value.find(
          (h) =>
            h.ht_id ===
            selectedTemplate.value.lifecyclesHT[0].ht_id_empty_trigger
        );
        if (htTrigger.hrAdded) {
          selectedAction.value = selectedTemplate.value.lifecyclesHT[0];
          htTrigger.hr_id =
            currentFields.value && currentFields.value.length
              ? currentFields.value[0].value
              : "No " + htTrigger.ht_name; // TODO - link to template_lifecycle so is flexible
          htTrigger[
            "level" +
            hierarchies.value.find((x) => x.ht_id === htTrigger.ht_id)
              .linklevel
          ] = htTrigger.hr_id;
          htTrigger.isNew = true;
        } else {
          selectedAction.value = selectedTemplate.value.lifecyclesHT.find(
            (x) =>
              x.ht_id_empty_trigger === htTrigger.ht_id &&
              htTrigger.hr_id === -999
          );
        }
      }
      if (!selectedAction.value && selectedTemplate.value.lifecycles.length) {
        if (
          selectedTemplate.value.lifecycles.some(
            (x) => x.ht_id_can_add_node.length
          ) &&
          selectedHierarchies.value.some((h) => h.isNew && h.hr_id)
        ) {
          selectedAction.value = selectedTemplate.value.lifecycles.find(
            (x) => x.ht_id_can_add_node.length
          );
        } else if (multiLifecycles.value.length === 2) {
          selectedAction.value =
            multiLifecycles.value[selectedActionNonDefault.value ? 1 : 0];
        } else {
          selectedAction.value = selectedTemplate.value.lifecycles.find(
            (x) => x.lifecycle_action_id === selectedActionId.value
          );
        }
      }
    }

    function isCreateAllowed() {
      setSelected();

      applicableHierarchyTypes.value.forEach((h) => {
        h.lostFocus = true;
      });

      //if (!$refs.createDocForm.validate()) return false;

      // let reqIdRequired =
      //   showReqField && !selectedTemplate?.usesWorkflow
      //     ? reqIdRequired
      //       ? true
      //       : false
      //     : false;

      // let dataCaptures = distinctDataCaptures.value || [];
      // let isValid = (value, mandatory, format_regex) => {
      //   const regex = format_regex ? new RegExp(format_regex) : null;
      //   if ((!value && mandatory) || (value && regex && !regex.test(value))) {
      //     return false;
      //   } else {
      //     return true;
      //   }
      // };
      // let dataCapturesValid = true;
      // dataCaptures
      //   .filter((dc) => !dc.questionnaire_id)
      //   .forEach((dc) => {
      //     if (dc.inputs.length) {
      //       dc.inputs.forEach((ip) => {
      //         if (
      //           !isValid(ip.value, dc.data_capture_mandatory, ip.format_regex)
      //         )
      //           dataCapturesValid = false;
      //       });
      //     } else {
      //       if (!isValid(dc.value, dc.data_capture_mandatory, dc.format_regex))
      //         dataCapturesValid = false;
      //     }
      //   });

      let creationDisabled =
        applicableHierarchyTypes.value.filter((h) =>
          useTreePicker ? !!h.treePickerValue : h.hierarchy_text
        ).length !== applicableHierarchyTypes.value.length // ||
      //(!recruiter && !hideRecruiter) ||
      //(reqIdRequired ? !requisition_number : false) ||
      //!dataCapturesValid;

      // if (!creationDisabled) {
      //   fileUploadFormData = {
      //     hr_ids: [],
      //     hierarchies: [],
      //     doc_id: [],
      //     doc_type: docType,
      //     createFiles: true,
      //     action: null,
      //     parseDoc: false,
      //     selectdTranslateLang: selectedTranslateLang,
      //     docClassifiers: [],
      //   };
      //   applicableHierarchyTypes.forEach((dh) => {
      //     if (dh.hierarchy_text) {
      //       let rootHierarchy = applicableHierarchyTypes.filter(
      //         (rh) => rh.ht_id == dh.ht_id
      //       );
      //       if (rootHierarchy) {
      //         let matchedHierarchy = rootHierarchy[0].values.find(
      //           (h) => h.text == dh.hierarchy_text
      //         );
      //         if (matchedHierarchy) {
      //           fileUploadFormData.hr_ids.push(matchedHierarchy.value);
      //         }
      //       }
      //     } else {
      //       if (dh.treePickerValue) {
      //         fileUploadFormData.hr_ids.push(dh.treePickerValue);
      //       }
      //     }
      //   });

      //   if (docType == "External File") {
      //     fileUploadFormData.createFiles = false;
      //     fileUploadFormData.parseDoc = false;
      //   }

      //   let data = checkNew();
      //   if (data) {
      //     fileUploadFormData.action = data.action;
      //     fileUploadFormData.hierarchies = data.hierarchies;
      //     fileUploadFormData.recruiter = data.recruiter;
      //     fileUploadFormData.extraFields = data.extraFields;
      //     if (data.dataCaptures) {
      //       fileUploadFormData.dataCaptures = data.dataCaptures;
      //     }
      //     if (data.docClassifiers && data.docClassifiers.length) {
      //       fileUploadFormData.docClassifiers = data.docClassifiers;
      //     }
      //   }

      //   fileUploadFormData = JSON.parse(
      //     JSON.stringify(fileUploadFormData)
      //   );
      // }

      return !creationDisabled;
    }

    function checkNew() {
      if (!selectedTemplate.value) return;
      if (selectedTemplate.value.usesWorkflow && !selectedAction.value) return;
      let data = {
        // recruiter: hideRecruiter
        //   ? loginState.user.name
        //   : recruiter,
        recruiter: loginState.user.name,
        docType: selectedTemplate.value.tmpl_name,
        //language: selectedTranslateLang,
        hierarchies: selectedHierarchies.value,
        // docClassifiers: docClassifiers.map((c) => {
        //   return {
        //     ct_id: c.ct_id,
        //     cv_id: c.selected?.cv_id,
        //   };
        // }),
        action: selectedAction.value,
        inheritSkills: useInheritSkills.value
      };

      // if (
      //   !selectedTemplate.value.usesWorkflow &&
      //   requisition_number !== ""
      // ) {
      //   data.requisition_numbers = requisition_number;
      // }

      if (currentFields.value.length > 0) {
        data.extraFields = currentFields;
      }

      // if (
      //   selectedTemplate.usesWorkflow &&
      //   distinctDataCaptures.length
      // ) {
      //   data.dataCaptures = distinctDataCaptures.map((x) => x);
      //   data.dataCaptures.forEach((dc) => {
      //     if (dc.method === "requisition") {
      //       dc.requisitions = [
      //         {
      //           isNew: true,
      //           requisition_number: dc.value,
      //         },
      //       ];
      //     }
      //   });
      // }

      return data;
    }
    function createDocument(uploaded) {
      if (!isCreateAllowed()) {
        return false;
      }

      let data = checkNew();
      if (!data) return;

      viewState.value = 'loading';
      axios
        .post("document/createDocument/", data)
        .then(async (resp) => {
          if (resp.data.Status === "OK") {
            //clearFilters();
            creationDisabled.value = true;
            if (data.hierarchies.some((x) => x.isNew))
              store.dispatch("hierarchies/refresh");

            //emit('docCreated', resp.data.Data);
            newDoc.value = resp.data.Data
            startEvaluation()
          } else {
            emit('error', resp.data.Message || 'Error creating document');
          }
          response.value = resp.data;
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            emit("sessionExpired", err);
          } else {
            console.log(err);
            emit('error', err.response?.data || 'Error creating document');
          }
        });
    }

    function closeAddDocument() {
      // this.creationDisabled = true;
      // this.hierarchies.splice(0);
      emit("closed");
    }

    function startEvaluation() {
      router.push({ name: 'evaluate', params: { docReference: newDoc.value.system_number, isNew: true } });
      closeAddDocument();
    }

    return {
      loginState,
      viewState,
      message,
      closeAddDocument,
      levellingTemplates,
      selectedTemplate,
      applicableHierarchyTypes,
      useTranslation,
      onHrySelect,
      nodeAdded,
      fileUploadFormData,
      isCreateAllowed,
      createDocument,
      newDoc,
      startEvaluation,
    }
  }
})
</script>

<template>
  <div class="lvl-eval">
    <v-card class="createNewCard">
      <v-toolbar fixed dense flat color="transparent">
        <v-spacer></v-spacer>
        <v-btn
          large
          icon
          class="btn-background ml-2"
          @click="closeAddDocument"
          title="Close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row justify="center" align="center">
          <v-col cols="12">
            <v-container v-if="viewState === 'loading'" class="fill-height">
              <v-row justify="center" align="center">
                <v-col cols="auto" class="text-center">
                  <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
                  <p class="mt-4 text-h6">Please wait...</p>
                </v-col>
              </v-row>
            </v-container>
            <v-card v-else-if="viewState === 'message'" class="landing-card" elevation="0">
              <v-card-text class="pa-8 pt-0">
                <h2 class="landing-title">{{ message }}</h2>
              </v-card-text>

              <!-- Footer -->
              <v-divider></v-divider>
              <div class="card-footer">
                <div class="footer-buttons">
                  <v-btn
                    color="success"
                    class="btn-next"
                    @click="closeAddDocument"
                  >
                    Close
                  </v-btn>
                </div>
              </div>
            </v-card>
            <v-card v-else-if="viewState === 'hierarchy'" class="landing-card" elevation="0">
              <v-card-text class="pa-8 pt-0">
                <!-- Header -->
                <div class="section-label"></div>
                <h1 class="landing-title">Collecting the information to create the role in the right place</h1>

                <!-- Description -->
                <p class="landing-description">
                  We need to place your role within the context of all the roles in {{ loginState.user.client }}&apos;s
                  work architecture.
                  Please select the best-matching category for your role.
                </p>

                <v-row v-if="levellingTemplates.length > 1">
                  <v-col cols="4" class="input-label">
                    <v-label for="evaluateNew_template">Document Type</v-label>
                  </v-col>
                  <v-col class="input-field">
                    <v-select
                      id="evaluateNew_template"
                      :items="levellingTemplates"
                      item-text="tmpl_name"
                      return-object
                      v-model="selectedTemplate"
                      placeholder="Please select a template"
                      outlined
                      hide-details
                      class="roundish"
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row v-for="(h) in applicableHierarchyTypes" :key="h.ht_id">
                  <v-col cols="4" class="input-label">
                    <v-label :for="`evaluateNew_${h.ht_name}`">{{ h.ht_name }}</v-label>
                  </v-col>
                  <v-col class="input-field">
                    <HierarchyTreePicker :id="`evaluateNew_${h.ht_name}`" v-model="h.treePickerValue" :label="h.label"
                      :options="h.treePickerOptionsActive" placeholder="Please select" :hierarchyType="h" :init="true"
                      :error="h.lostFocus && !h.treePickerValue" :hint="h.lostFocus && !h.treePickerValue ? 'Required' : ''
                        " @change="onHrySelect(h, ...arguments)" @nodeAdded="nodeAdded(h, ...arguments)"
                      @lostFocus="h.lostFocus = true">
                    </HierarchyTreePicker>
                  </v-col>
                </v-row>
              </v-card-text>

              <!-- Footer -->
              <v-divider></v-divider>
              <div class="card-footer">
                <div class="footer-buttons">
                  <button type="button" class="lvl-btn lvl-btn--outlined mr-2" @click="closeAddDocument">Cancel</button>
                  <button type="button" class="lvl-btn" @click="createDocument">Next <span class="ms">arrow_forward</span></button>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<style lang="scss" src="./evaluationTheme.scss"></style>
<style scoped lang="scss">

.v-toolbar {
  border: 0 !important;
  padding: 10px;
  margin-bottom: 10px;
  .v-toolbar__title {
    font-size: 1.375rem;
  }
}

.landing-card {
  border-radius: 16px !important;
  position: relative;
}

.help-icon {
  position: absolute;
  top: 16px;
  right: 16px;
}

.section-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
}

.landing-title {
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
  color: #1a1a1a;
  margin-bottom: 16px;
  font-family: Georgia, 'Times New Roman', serif;
}

.landing-description {
  font-size: 15px;
  line-height: 1.6;
  margin-bottom: 16px;
}

.input-label {
  font-size: 14px;
  font-weight: 400;
  padding-top: 28px;
  text-align: right;
  padding-bottom: 0;
}

.input-field {}

.flow-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.flow-option {
  display: flex;
  gap: 16px;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.flow-option:hover {
  border-color: #7cb342;
  background-color: #fafafa;
}

.flow-radio {
  flex-shrink: 0;
  padding-top: 4px;
}

.flow-radio-outer {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid #ccc;
  transition: border-color 0.2s;
}

.flow-option:hover .flow-radio-outer {
  border-color: #7cb342;
}

.flow-content {
  flex: 1;
}

.flow-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.flow-name {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
}

.flow-badge {
  font-size: 11px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 4px;
  background-color: #e0e0e0;
  color: #666;
  text-transform: uppercase;
}

.flow-badge--recommended {
  background-color: #e8f5e9;
  color: #7cb342;
}

.flow-description {
  font-size: 14px;
  line-height: 1.5;
  color: #666;
  margin: 0;
}

.card-footer {
  padding: 20px 32px;
  text-align: right;
}

.footer-text {
  font-size: 14px;
  color: #888;
}
</style>
